import { Capacitor } from '@capacitor/core';
import { SITE_URL } from '../config/env.js';

/** True when running inside Capacitor Android or iOS shell */
export function isNativeApp() {
  return Capacitor.isNativePlatform();
}

export function nativePlatform() {
  return Capacitor.getPlatform();
}

export function isAndroid() {
  return Capacitor.getPlatform() === 'android';
}

export function isIOS() {
  return Capacitor.getPlatform() === 'ios';
}

/** HTTPS redirect registered on the Web OAuth client (Google requires http/https). */
export const MOBILE_OAUTH_REDIRECT = `${SITE_URL}/app/oauth2redirect.html`;

/** Custom scheme — bridge page above forwards the token into the app. */
export const MOBILE_APP_CALLBACK = 'com.repatikosam.app://oauth2redirect';
